module.exports = __webpack_public_path__ + "media/images/common/select_allow-d1d942c72b511e710b2d7b745af0ffcd.png";